import React from 'react';
import { Controller } from 'react-hook-form';
import { LiliCheckbox } from '../../../DesignSystem/LiliCheckbox/LiliCheckbox';
import Heading from '../../../generic-components/Heading';

interface IProps {
    item: any;
    control: any;
    shouldHideField?: boolean;
}

export const RenderCheckbox = ({
  item, control, shouldHideField,
}: IProps) => (
  <div className={`${shouldHideField ? 'hidden' : ''} fadeIn basis-1/2`}>
    <Controller
      name={item.inputId}
      control={control}
      render={({ field }) => (
        <div className='flex items-center gap-[6px]'>
          <LiliCheckbox
            id={`checkbox-${item.inputId}`}
            checked={field.value}
            onCheckedChange={() => { field.onChange(!field.value); }}
          />
          <Heading title={item.name} className='font-metricR text-bw07 text-md' />
        </div>
      )}
    />
  </div>
);
